enum AppStatus {
    Pending = 10,
    Active = 90,
}

export default AppStatus;